import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"icon-arrow-left\">\n<path id=\"icon-arrow-left_路径\" d=\"M248.7,507.4c-0.2,13,4.4,24.5,14.4,34.5l418,409.2c8.9,9.5,20.7,14.4,34.7,14.6c27.9,0.5,49.6-19.3,50.1-46.3\n\tc0.2-13.5-5.5-25-13.9-33.9L368.2,509.5l396.7-362.2c8.8-8.6,14.9-20.4,15.1-33.4c0.5-27-20.6-47.6-48.5-48.1\n\tc-13.9-0.2-25.8,4.3-35.1,12.9L264.3,473.5C254,482.6,249,494.4,248.7,507.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol